module.exports = __webpack_public_path__ + "img/DELIVERY.1b8d0d23.svg";